export const STATISTICS_CONSTANTS = {
  TOP_USERS_LIMIT: 10,
  DEFAULT_CHART_HEIGHT: 300,
  MOBILE_CHART_HEIGHT: 250,
  SKELETON_HEIGHT: 250,
  MOBILE_SKELETON_HEIGHT: 300,
} as const

export const ACCORDION_SECTIONS = {
  OVERVIEW: 'overview',
  DURATION: 'duration',
  AI_USAGE: 'aiUsage',
  DAILY: 'daily',
  WEEKLY: 'weekly',
} as const

export const TAB_INDICES = {
  SUMMARY: 0,
  DETAILED: 1,
} as const
